import React from 'react'
import { Trans, withTranslation } from 'react-i18next'

const EmptyTable = () => {
  return (
    <p className="empty-list">
      <Trans>No se han encontrado resultados para su busqueda</Trans>
    </p>
  )
}

export default withTranslation()(EmptyTable)
